/* Summit Line Scout event telemetry v1 — QA theme only.
   No raw questions, conversation bodies, emails, IP addresses or stable IDs sent.
   Events are sent only when Shopify's customerPrivacy explicitly allows analytics.
*/
(() => {
  "use strict";
  if (window.__summitScoutAnalyticsV1) return;
  window.__summitScoutAnalyticsV1 = true;
  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; }
    catch (_) { return false; }
  };
  const send = (name, params = {}) => {
    if (!allowed() || typeof window.gtag !== "function") return;
    window.gtag("event", name, {
      event_category: "scout_storefront",
      page_type: document.body.classList.contains("template-product") ? "product" : "other",
      ...params
    });
  };
  let seq = 0;
  const pending = new WeakMap();
  document.addEventListener("click", (event) => {
    const element = event.target instanceof Element ? event.target : null;
    if (!element) return;
    if (element.closest("[data-scout-mobile-open], [data-scout-expand]")) send("scout_opened");
    const dock = element.closest(".scout-dock-v2");
    if (!dock) return;
    if (element.closest("[data-scout-mobile-close]")) send("scout_closed");
    if (element.closest("[data-scout-refine-go]")) send("scout_filter_applied");
    if (element.closest("[data-scout-talk], [data-scout-voice]")) send("scout_voice_clicked");
    if (element.closest("[data-scout-action]")) send("scout_action_clicked", {action: (element.closest("[data-scout-action]").getAttribute("data-scout-action") || "unknown").slice(0, 40)});
    const link = element.closest("a[href]");
    if (link) {
      let path = "";
      try { path = new URL(link.href).pathname; } catch (_) {}
      if (path.startsWith("/products/")) send("scout_product_clicked");
      else if (path.startsWith("/collections/")) send("scout_collection_clicked");
      else if (path.startsWith("/pages/")) send("scout_page_clicked");
    }
  }, {passive:true});
  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(".scout-dock-v2 [data-scout-form]")) return;
    const dock = form.closest(".scout-dock-v2");
    const input = form.querySelector("[data-scout-input]");
    if (!dock || !input?.value?.trim()) return;
    const number = ++seq;
    pending.set(dock, {number, at: performance.now(), done: false});
    send("scout_question_sent");
  }, true);
  const observeDock = dock => {
    const response = dock.querySelector("[data-scout-response]");
    const body = dock.querySelector("[data-scout-response-text]");
    if (!response || !body) return;
    const observer = new MutationObserver(() => {
      const state = pending.get(dock);
      if (!state || state.done || response.hidden) return;
      const message = (body.textContent || "").trim();
      if (!message || /^(Checking Summit Line products|Scout is researching your question)/i.test(message)) return;
      state.done = true;
      const failed = /Scout could not complete|Scout is taking too long|try again/i.test(message);
      send(failed ? "scout_answer_failed" : "scout_answer_displayed", {response_ms: Math.round(performance.now()-state.at)});
    });
    observer.observe(response, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:["hidden"]});
  };
  const init = () => document.querySelectorAll(".scout-dock-v2").forEach(observeDock);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, {once:true});
  else init();
})();
